// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"85e632d0","105":"5ce8db38","310":"e952bfb4","466":"bcb457d9","508":"8df16d07","671":"f43b8824","780":"9d7fa284","966":"5bd6a574"}[chunkId] + ".chunk.js";
};